import { IGetBetPositionRequest } from '../../../../../services/auction/getBetPosition';
import { EBetPositionErrorCode, IAuctionState } from '../../../../reducers';

interface IValidateBetPositionParams {
  stepBet: number;
  auction: IAuctionState;
  isAuctionBetEnabled: boolean;
}

export function validateBetPositionParams(
  request: IGetBetPositionRequest,
  params: IValidateBetPositionParams,
): EBetPositionErrorCode | undefined {
  const { bet, price, geoType, geoId, service } = request;
  const { stepBet, auction, isAuctionBetEnabled } = params;
  const { minimalBet, maximalBet } = auction;

  const isPriceEmpty = !price;
  const isGeoEmpty = !geoId || !geoType;

  if (isPriceEmpty && isGeoEmpty) {
    return EBetPositionErrorCode.priceAndGeoEmpty;
  }

  if (isGeoEmpty) {
    return EBetPositionErrorCode.geoEmpty;
  }

  if (isPriceEmpty) {
    return EBetPositionErrorCode.priceEmpty;
  }

  if (!service) {
    return EBetPositionErrorCode.serviceNotSupported;
  }

  if (isAuctionBetEnabled && bet && bet < minimalBet) {
    return EBetPositionErrorCode.minimalBetReached;
  }

  if (isAuctionBetEnabled && bet && bet > maximalBet) {
    return EBetPositionErrorCode.maximalBetReached;
  }

  if (isAuctionBetEnabled && bet % stepBet) {
    return EBetPositionErrorCode.betNotDivided;
  }

  return undefined;
}
